import { getDefaultRequestOptions } from 'owa-headers';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ClientItemId } from 'owa-client-ids';
import getBirthdayEventRequest from 'owa-service/lib/factory/getBirthdayEventRequest';
import itemId from 'owa-service/lib/factory/itemId';
import getBirthdayEventOperation from 'owa-service/lib/operation/getBirthdayEventOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import calendarEventFromBirthdayEvent from '../utils/calendarEventFromBirthdayEvent';
import BirthdayEvent from 'owa-service/lib/contract/BirthdayEvent';
import GetBirthdayEventJsonResponse from 'owa-service/lib/contract/GetBirthdayEventJsonResponse';

/**
 * Makes the GetBirthdayEvent call to the server to get the calendar event object
 * @param calendarEventId id of the calendar event that needs to be fetched
 * @param parentFolderId the folder Id of the event
 */
export async function getBirthdayEventService(
    calendarEventId: ClientItemId,
    parentFolderId: string
): Promise<CalendarEvent> {
    const { Id: id, mailboxInfo } = calendarEventId;

    const requestOptions = getDefaultRequestOptions(mailboxInfo) || {};
    requestOptions.datapoint = {
        customData: {
            itemId: id,
        },
        jsonCustomData: (json: GetBirthdayEventJsonResponse) => ({
            responseClass: json && json.Body && json.Body.ResponseClass,
            responseCode: json && json.Body && json.Body.ResponseCode,
        }),
    };
    const response = await getBirthdayEventOperation({
        Header: getJsonRequestHeader(),
        Body: getBirthdayEventRequest({
            CalendarItemId: itemId({ Id: id }),
        }),
    });

    if (response.Body != null && response.Body.ResponseClass == 'Success') {
        let birthdayEvent = response.Body.BirthdayEvent as BirthdayEvent;
        if (birthdayEvent != null) {
            return calendarEventFromBirthdayEvent(
                birthdayEvent,
                parentFolderId,
                undefined,
                calendarEventId.mailboxInfo
            );
        }
    }

    // In case of error, we are ignoring it
    return null;
}
